<template>
  <div class="container-lg">
    <h1 class="page-header">Companies &amp; Contacts</h1>

    <DbTableControl :buttons="buttons"></DbTableControl>

    <div class="table table-responsive table-sm">
      <table class="table">
        <thead>
          <tr>
            <th>Type</th>
            <th>Name</th>
            <th>Address</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="i in items" :key="i.id">
            <td class="text-center">
              <i v-if="i.entity_type_id === 1" class="fa fa-building" title="Company"></i>
              <i v-else-if="i.entity_type_id === 2" class="fa fa-user" title="Contact"></i>
              <span v-else>{{ i.type_name }}</span>
            </td>
            <td class="text-nowrap">
              <router-link class="d-block" :to="'/entity/' + i.id">{{ i.name }}</router-link>
            </td>
            <td>
              {{ i.address }}
              <br />
              {{ i.postcode }}
            </td>
            <td>
              <div v-if="i.telephone">Tel.: {{ i.telephone }}</div>
              <div v-if="i.mobile">Mob.: {{ i.mobile }}</div>
              <div v-if="i.email">
                <a :href="'mailto:' + i.email">{{ i.email }}</a>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr v-show="showMore">
            <td colspan="8">
              <button class="btn btn-info" @click="handleMore()">Load more...</button>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import { createWhereTextSearch } from "../lib/sql.js";
import { authFetch } from "../lib/auth.js";
import dbTableMixin from "../lib/dbtable-mixin";
import DbTableControl from "../components/DbTableControl"

export default {
  mixins: [dbTableMixin],
  components: {
    DbTableControl,
  },
  data() {
    return {
      buttons: [
        {
          to: "/entity?type=2",
          text: "Add contact",
          fa: "user",
          accesskey: "c"
        },
        {
          to: "/entity?type=1",
          text: "Add company",
          fa: "building",
          accesskey: "a"
        }
      ],
      items: [],
      limit: 25,
      offset: 0,
      showMore: false,
    };
  },
  methods: {
    handleMore() {
      this.offset += this.limit;
      this.load();
    },
    load() {
      let whereArray = [];
      if (this.searchtext) {
        whereArray.push(encodeURIComponent(createWhereTextSearch(this.searchtext, [
          'name',
          'address',
          'postcode',
          'telephone',
          'mobile',
          'email',
          ])))
      }
      // if (this.entity_type_filter > 0) {
      //   whereArray.push(`entity_type_id = ${this.entity_type_filter}`)
      // }
      let where = ""
      if (whereArray.length > 0) {
        where += whereArray.join(" AND ")
      }
      authFetch(`/db/entity_view?sort=name&limit=${this.limit+1}&offset=${this.offset}` + ( where ? "&where=" + where : ""))
        .then(resp => resp.json())
        .then(newItems => {
          this.showMore = false;
          if (newItems.length > this.limit) {
            this.showMore = true;
            newItems.pop();
          }
          if (this.offset === 0) {
            this.items = newItems;
          } else {
            this.items = this.items.concat(newItems);
          }
        })
    },
  },
};
</script>